export const iconFontAwesomeWeatherBoltLightning = (
	<i className="fa-solid fa-bolt-lightning"></i>
);
